import {ClsErrores} from './cls-errores';
import {EnumCapturarPor} from "./enum/enum-programacion-obra";

export class ClsUnidades {
  IdUnidad?: string;
  Unidad: string;
  DescripcionUnidad: string;
}

export class ClsTipoInsumos {
  IdTipoInsumo?: number;
  TipoInsumo: number;
  DescripcionTipoInsumo: string;
}

export class ClsTipoAnticipos {
  IdTipoAnticipo: number;
  TipoAnticipo?: number;
  DescripcionTipoAnticipo: string;
}

export class ClsTipoJornada {
  IdTipoJornada: number;
  TipoJornada?: number;
  DescripcionTipoJornada: string;
}

export class ClsInsumosCalculado {
  TipoInsumo: number;
  DescripcionTipoInsumo: string;
  Importe: number;
  Porcentaje: number;
}

export class ClsFamilias {
  IdFamilia: bigint;
  Familia: string;
  DescripcionFamilia: string;
}

export class ClsEstados {
  IdEstado: bigint;
  Estado: string;
  NombreEstado: string;
}

export class ClsCiudades {
  IdCiudad: bigint;
  Ciudad: string;
  DescripcionCiudad: string;
  IdEstado: bigint;
  CodigoEstado: string;
  NombreEstado: string;
  Estado?: ClsEstados;
}

export class ClsProveedores {
  IdProveedor: bigint;
  Proveedor: string;
  IdCiudad: bigint;
  DescripcionCiudad: string;
  Ciudad?: ClsCiudades;
  RazonSocial: string;
  RfcProveedor: string;
  DireccionProveedor: string;
  ColoniaProveedor: string;
  CodigoPostalProveedor: string;
  TelefonoProveedor: string;
  FaxProveedor: string;
  MailProveedor: string;
  ContactoProveedor: string;
  ObservacionesProveedor: string;
  CelularProveedor: string;
  PaginaWebProveedor: string;
  ProveedorDefault: boolean;
}

export class ClsResponsables {
  IdResponsable: bigint;
  Responsable: string;
  NombreResponsable: string;
  CargoResponsable: string;
  TelefonoResponsable: string;
  MailResponsable: string;
}

export class ClsClientes {
  IdCliente: bigint;
  Cliente: string;
  NombreCliente: string;
  DireccionCliente: string;
  ColoniaCliente: string;
  IdCiudadCliente: bigint;
  DescripcionCiudadCliente: string;
  Ciudad?: ClsCiudades;
  CodigoPostalCliente: string;
  TelefonoCliente: string;
  MailCliente: string;
}

export class ClsContactoCliente {
  IdClienteContactoSql?: bigint;
  IdClienteContacto: bigint;
  IdCliente?: bigint;
  NombreClienteContacto: string;
  CargoClienteContacto: string;
  TelefonoClienteContacto: string;
  MailClienteContacto: string;
  NombreCliente?: string;
  Cliente?: ClsClientes;
}

export class ClsEmpresas {
  IdEmpresa: bigint;
  Empresa?: string;
  RazonSocialEmpresa: string;
  IdCiudadEmpresa: bigint;
  DescripcionCiudad: string;
  Ciudad?: ClsCiudades;
  DireccionEmpresa: string;
  Colonia: string;
  IdResponsableEmpresa: bigint;
  NombreResponsable: string;
  Responsable?: ClsResponsables;
  TelefonoEmpresa: string;
  MailEmpresa: string;
  IMSSEmpresa: string;
  CMICEmpresa: string;
  InfonavitEmpresa: string;
  FaxEmpresa: string;
  RfcEmpresa: string;
  CodigoPostalEmpresa: string;
  SitioWeb: string;
}

export class ClsCalendario {
  IdCalendario: bigint;
  CodigoCalendario: string;
  DescripcionCalendario: string;
  Lunes: boolean;
  Martes: boolean;
  Miercoles: boolean;
  Jueves: boolean;
  Viernes: boolean;
  Sabado: boolean;
  Domingo: boolean;
  Predeterminado: boolean;
  JsonFechas: string;
  Fechas?: ClsCalendarioFecha[];
}

export class ClsCalendarioFecha {
  IdFecha: number;
  FechaNoLaborable: Date;
  Descripcion: string;
}

export class ClsVendedores {
  // IdVendedorSql: bigint;
  IdVendedor: bigint;
  Vendedor: string;
  NombreVendedor: string;
  CargoVendedor: string;
  TelefonoVendedor: string;
  MailVendedor: string;
}

export class ClsTipoLicitaciones {
  // IdTipoLicitacionSql?: bigint;
  IdTipoLicitacion: bigint;
  TipoLicitacion: string;
  DescripcionTipoLicitacion: string;
}

export class ClsRegion {
  IdRegion?: string;
  Region: string;
  DescripcionRegion: string;
}

export class ClsListaCatalogos {
  LsCatalogo: ClsCatalogoImporte[];
  Errores: ClsErrores;
}

class ClsCatalogoImporte {
  DescripcionTipoInsumo: string;
  ImporteMoneda1: number;
  ImporteMoneda2: number;
  PorcentajeMoneda1: number;
  PorcentajeMoneda2: number;
  TipoInsumo: number;
}

export class ClsAnioPorcentajeAplicacion {
  IdCuotasVigentesImss: number;
  Clave: string;
  CuotaFijaPat: number;
  ExcedentePat: number;
  ExcedenteAse: number;
  PrestDinPat: number;
  PrestDinAse: number;
  GastoMedPenPat: number;
  GastoMedPenAse: number;
  InvalidezVidaPat: number;
  InvalidezVidaAse: number;
  GuarderiasPat: number;
  RetiroPat: number;
  CesantiaVejezPat: number;
  CesantiaVejezAse: number;
  LimiteSuperior1: number;
  LimiteSuperior2: number;
}
